module.exports = __webpack_public_path__ + "images/fa-cfa-review-8.webp";